// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"NotificationsSettings_checkboxContainer__eJpbp"};